export const COLOR_BLUE = '#0968C3';
export const COLOR_DARK_BLUE = '#064785';
export const COLOR_DARKER_BLUE = '#0b2569';
export const COLOR_PRIMARY = COLOR_BLUE;
export const COLOR_GREY = '#808080';
export const COLOR_LIGHT_GREY = '#D3D3D3';
export const COLOR_BLACK = '#000';
export const COLOR_WHITE = '#fff';
export const COLOR_WARNING = '#ffc107';
export const COLOR_ERROR = '#dc3545';

export const COLOR_ICON_WITH_INFO = COLOR_BLACK;
export const COLOR_ICON_WITHOUT_INFO = COLOR_LIGHT_GREY;

export const COLOR_SOMATIC = COLOR_BLUE;
